import * as React from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';

import GoogleSocialAuth from "./auth/GoogleSocialAuth";
import FacebookSocialAuth from "./auth/FacebookSocialAuth";
import AuthLayout, { TRUE_MUTED, primaryButtonSx, mutedLinkStyle, strongLinkStyle } from "./auth/AuthLayout";

import AuthContext from "../context/AuthContext";
import { Link } from 'react-router-dom'

const hasSocialAuth = !!process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Login = () => {

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');

  const { loginUser } = React.useContext(AuthContext);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const username = String(data.get('email'))
    const password = data.get('password')
    if (username.length > 0) {
      const code = await loginUser(username, password);
      if (code === 1) {
        setOpen(true);
        setMessage('Usuario o contraseña incorrectos');
      } else if (code === 2) {
        setOpen(true);
        setMessage('Error al iniciar sesión con aplicación de terceros. Intente con su usuario y contraseña o contacte al administrador');
      }
    }
  }

  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert onClose={() => setOpen(false)} severity="error" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>

      <AuthLayout title="Bienvenido" subtitle="Inicia sesión en tu cuenta">
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo electrónico"
            name="email"
            autoComplete="email"
            autoFocus
            size="small"
            sx={{ mb: 1 }}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type="password"
            id="password"
            autoComplete="current-password"
            size="small"
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5, mb: 2 }}>
            <Link to="/request-password-reset" style={mutedLinkStyle}>
              ¿Olvidaste tu contraseña?
            </Link>
          </Box>

          <Button type="submit" fullWidth variant="contained" sx={primaryButtonSx}>
            Ingresar
          </Button>

          {hasSocialAuth && (
            <>
              <Divider sx={{ my: 3, color: '#A3A39B', fontSize: '0.8rem' }}>o continúa con</Divider>
              <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', mb: 3 }}>
                <GoogleSocialAuth />
                <FacebookSocialAuth />
              </Stack>
            </>
          )}

          <Typography variant="body2" sx={{ textAlign: 'center', color: TRUE_MUTED, fontFamily: 'Inter, sans-serif', mt: hasSocialAuth ? 0 : 3 }}>
            ¿No tienes cuenta?{' '}
            <Link to="/register" style={strongLinkStyle}>
              Regístrate
            </Link>
          </Typography>
        </Box>
      </AuthLayout>
    </>
  );
}

export default Login;
